var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 14.9932,
    width: 6.12987,
    height: 6.12987,
    rx: 1,
    transform: "rotate(135 19.5 14.9932)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.73438,
    y: 21.7847,
    width: 4.57951,
    height: 4.57951,
    rx: 1,
    transform: "rotate(135 9.73438 21.7847)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1748,
    y: 6.16504,
    width: 8.25567,
    height: 8.25567,
    rx: 1,
    transform: "rotate(135 12.1748 6.16504)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBtnIcon);
export default __webpack_public_path__ + "static/media/rightBtnIcon.703a4ed1dea2c058af60e5113c297854.svg";
export { ForwardRef as ReactComponent };